import script from "./DocumentTypeGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentTypeGrid.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentTypeGrid.vue?vue&type=style&index=0&id=3d6a63bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d6a63bd"]])

export default __exports__